export default "__VITE_ASSET__DEI5pVoT__"